import restTypes from '../util/rest/types';
import restStates from '../util/rest/states';
import restInitState from '../util/rest/initState';

const initialState = {};
const previewFieldAttributeRestTypes = restTypes('preview_field_attribute');

export default (state = { ...restInitState, ...initialState }, action = {}) => {
  switch (action.type) {
    case previewFieldAttributeRestTypes.fetchAllStart:
      return {
        ...state,
        ...restStates.fetchAllStart,
      };
    case previewFieldAttributeRestTypes.fetchAllFinished:
      return {
        ...state,
        ...restStates.fetchAllFinished,
        list: action.payload,
      };
    default: return state;
  }
};
